module.exports = __webpack_public_path__ + "static/media/map.05c58189.svg";